import { useState, useEffect, useMemo, useContext } from 'react';
import { callautopopulate } from '../../../services/callautopop';
import services from '../../../services/services';
import { Urls } from '../../../services/Urls';
import _ from 'underscore';
import { ToastContext } from '../../../context/ToastContext';
import { dateHoverRange } from '../../../utils/Helper';


export const useImportData = () => {
    const { showInfo,showError,showSuccess } = useContext(ToastContext);
    const [products, setProducts] = useState([]);
    const [spinner, setSpinner] = useState({});
    const [info, setInfo] = useState({ visible: '', message: '' });
    const [userOption, setUserOption] = useState([]);
    const [filterValue, setFilterValue] = useState({ hoveredRange: [null, null] })


    useEffect(() => {
        sessionStorage.removeItem("product_apis")
        callautopopulate("product_apis", "users").then(res => {
            setProducts(res?.product_apis)
            setUserOption(_.sortBy(res?.users, "user_display_name"));
        });
    }, []);

    const handleUpsertImportData = async (event, value, selectedEmployee, key) => {
        const trueKeys = Object.values(spinner)?.includes(true);
        if (trueKeys && key !== "timesheet") {
            showInfo('info', 'Waiting for the previous process to complete. Please hold on.')
            return;
        } else {
            setInfo({ visible: '', message: '' });
            setSpinner((prevState) => ({ ...prevState, [event.api_key]: true }))
            const payload = {
                "import_api_key": event?.api_key,
                "from_date": key === "timesheet" ? value?.importDate[0] ? dateHoverRange(value?.importDate[0]) : "" : filterValue?.hoveredRange[0] ? dateHoverRange(filterValue?.hoveredRange[0]) : "",
                "to_date": key === "timesheet" ? value?.importDate[1] ? dateHoverRange(value?.importDate[1]) : "" : filterValue?.hoveredRange[1] ? dateHoverRange(filterValue?.hoveredRange[1]) : "",
                "employee_id": key === "timesheet" ? selectedEmployee?.employee_id : filterValue?.user?.employee_id || ""
            }
            try {
                const response = await services.getInvokeRemote('POST', Urls('UPSERTIMPORTDATA'), payload)
                if (response?.body?.data) {
                    if (key === "timesheet") {
                        showSuccess("Success", response?.body?.message)
                        return true
                    }
                    setSpinner((prevState) => ({ ...prevState, [event.api_key]: false }));
                    setInfo({ visible: 'success', message: response?.body?.message });
                } else {
                    if (key === "timesheet") {
                        showError("Error", response.body.errorMessage)
                    }
                }
            } catch (error) {
                if (key === "timesheet") {
                    showError("Error", error?.response?.data?.errorMessage)
                }
                setInfo({ visible: 'error', message: error?.response?.data?.errorMessage });
                console.error(error);
                setSpinner((prevState) => ({ ...prevState, [event.api_key]: false }));
            }
        }
    }



    return useMemo(() => ({
        products, handleUpsertImportData, spinner, info, userOption, filterValue, setFilterValue
    }), [products, handleUpsertImportData, spinner, info, userOption, filterValue, setFilterValue])
}